import React from "react";

const SvgFan21 = props => (
  <svg width={40} height={40} {...props}>
    <g
      fill="#FDFDFE"
      fillRule="evenodd"
      opacity={0.4}
      transform="translate(7 7)"
    >
      <rect width={3} height={11} y={17} rx={1.5} />
      <rect width={3} height={16} x={7} y={12} rx={1.5} />
      <rect width={3} height={23} x={15} y={5} fillOpacity={0.5} rx={1.5} />
      <rect width={3} height={28} x={23} fillOpacity={0.5} rx={1.5} />
    </g>
  </svg>
);

export default SvgFan21;
